// TOP LEVEL IMPORTS
import React from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';
// COMPONENTS
import LinkText from 'components/text/LinkText';
import WelcomeReminderModal from './WelcomeReminderModal';
import Logo from 'components/common/Logo';
import LoginForm from 'components/forms/LoginForm';
import AccountHelpers from 'lib/helpers/AccountHelpers';
import ApolloClient from 'ApolloClient';
import message from 'antd/lib/message';

// CONSTANTS & DESTRUCTURING
// ========================================

// STYLED-COMPONENTS
// ========================================
const AuthLogoContainer = styled.div`
  text-align: center;
  height: 135px;
  align-items: center;
  justify-content: center;
  display: flex;
`;

// EXPORTED COMPONENT
// ========================================
class LoginPage extends React.PureComponent {
  state = {
    formToShow: 'login',
  };

  state = {
    loading: false,
    errors: [], // holds errors from server, antd's FormItem handles displaying client validation errors of inputs
  };

  onSucessFullyValidated = async ({ username, password }) => {
    this.setState({ loading: true });

    let res;
    try {
      res = await AccountHelpers.handleLogin({ email: username.toLowerCase(), password });
    } catch (err) {
      return this.setState({
        loading: false,
        errors: [err.message.replace('GraphQL', '')],
      });
      // return console.log(err);
    }
    message.success('Welcome!');
    ApolloClient.resetStore();
  };

  onSuccessfulLogin = ({ access_token, refresh_token }) => {
    this.setState({ loading: false });
    message.success('Welcome back!');
    setTimeout(() => window.location.reload(), 800);
  };

  render() {
    if (this.props.currentUser && this.props.currentUser.id) {
      return <Redirect to="/" />;
    }
    return (
      <div style={{ maxWidth: '100%' }}>
        <div style={{ width: 400, maxWidth: '95%', margin: 'auto' }}>
          <AuthLogoContainer>
            <Logo />
          </AuthLogoContainer>
          <LoginForm
            loading={this.state.loading}
            errors={this.state.errors}
            onSucessFullyValidated={this.onSucessFullyValidated}
          />
          <LinkText
            style={{ textAlign: 'center', marginTop: 20, color: '#fff' }}
            onClick={() => this.props.history.push('/forgot-password')}
          >
            Forgot Password?
          </LinkText>
          <WelcomeReminderModal />
        </div>
      </div>
    );
  }
}

// EXPORT
// ========================================
export default LoginPage;



// WEBPACK FOOTER //
// ./src/routes/auth-login/index.js